import { type CMSPageType } from '@backmarket/http-api/src/api-specs-content'

import { HOME } from '~/scopes/home/route-names'

import { CMS } from '../routes-names'

/**
 * Mapping between the route name and its corresponding page type in the CMS.
 * The page type is provided to the content service call.
 */
export const CMS_PAGE_TYPE_BY_ROUTE_NAME = {
  [CMS.ARTICLE]: 'article',
  [CMS.BRAND_STORE]: 'brand-store',
  [CMS.BRAND_STORE_CATEGORY]: 'brand-store',
  [CMS.BUYBACK]: 'buyback',
  [CMS.BUYBACK_CATEGORY]: 'buyback',
  [CMS.E2E_PAGE]: 'end2EndTests',
  [CMS.EVENT]: 'event-page',
  [CMS.GIFT_FINDER_EVENT]: 'gift-finder',
  [CMS.GIFT_FINDER_MAIN]: 'gift-finder',
  [CMS.LEGAL_PREVIOUS_VERSION]: 'legal-document',
  [CMS.LEGAL_PAGE]: 'legal-page',
  [CMS.SELLER]: 'seller',
  [CMS.STATEMENT]: 'core',
  [CMS.THE_X]: 'the-x',
  [CMS.SERVICE]: 'service',
  [HOME]: 'core',
} satisfies Record<string, CMSPageType>

export const PAGE_NAME_BY_ROUTE_NAME: Record<string, string> = {
  [CMS.STATEMENT]: 'accessibility-statement',
  [HOME]: 'home',
}

export const PAGE_NAME_BY_PLP_SLUG: Record<string, string> = {
  'macbook-and-laptops': 'laptops',
  smartphones: 'smartphones',
}

export const OWNER_BY_PAGE_TYPE = {
  article: '[ACQ]',
  'brand-store': '[LIF]',
  buyback: '[BBACK]',
  core: '[LIF]',
  'event-page': '[LIF]',
  'gift-finder': '[ACQ]',
  'legal-document': '[ACQ]',
  'legal-page': '[ACQ]',
  seller: '[SELLER]',
  service: '[B2CS]',
  'the-x': '[COM]',
  end2EndTests: '[COM]',
} satisfies Record<CMSPageType, string>

export const PAGE_TYPE_WITH_SPECIFIC_FIELDS = [
  CMS_PAGE_TYPE_BY_ROUTE_NAME[CMS.LEGAL_PAGE],
  CMS_PAGE_TYPE_BY_ROUTE_NAME[CMS.LEGAL_PREVIOUS_VERSION],
]

export const PAGE_TYPE_WITH_NO_PARAMS_CORRECTION = [
  CMS_PAGE_TYPE_BY_ROUTE_NAME[CMS.LEGAL_PAGE],
  CMS_PAGE_TYPE_BY_ROUTE_NAME[CMS.LEGAL_PREVIOUS_VERSION],
]
